import { useDispatch, useSelector } from 'react-redux';
import CardTable from 'components/CardTable/CardTable';
import { useSearch } from 'hooks/useSearch';
import { useToggle } from 'hooks/useToggle';
import React, { useEffect } from 'react'
import { columns } from './columns';
import RegularButton from 'components/CustomButtons/Button';
import { ModalV2 } from 'components/Modal/ModalV2';
import Snackbar from 'components/Snackbar/Snackbar';
import GroupIcon from '@mui/icons-material/Group';
import { UserForm } from './UserForm';
import { useBuildUsersLoadings } from './hooks';
import { getCompaniesGod } from 'redux/actions/companies/companiesAction_V2';

const tableKey = "users";

export const UsersView = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useToggle();
  const { isOpen, color, message, configTables } = useSelector(
    ({ search }) => search
  );
  const { clearSnackbar, buildCompLoadings, buildTableConfig } = useSearch();
  const { users } = useSelector(({ users }) => users);
  const { rules } = useSelector(({ login }) => login);
  const { stationsGod} = useSelector(({ companies }) => companies);
  const { printers } = useSelector(({ printers }) => printers);
  useBuildUsersLoadings(users, printers, buildCompLoadings)

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
    rules.includes("ADMIN_GOD") && stationsGod.length === 0 && dispatch(getCompaniesGod()) 
  }, [])
  return (
    <>
      <CardTable
        columns={columns}
        data={users}
        hasControl
        hasHeader
        icon={<GroupIcon />}
        title="Usuarios"
        titleBlock
        blockBtn
        tableKey={tableKey}
        controls={
          <RegularButton
            round
            justIcon
            color="info"
            onClick={setOpen}
            tooltip="Agregar nuevo usuario"
            size="sm"
          >
            +
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        onClose={setOpen}
        title="Nuevo Usuario"
        toRight
      >
        <UserForm onClose={setOpen}/>
      </ModalV2>
      <Snackbar
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
}
